'use client';

import { useState } from 'react';

import { IoGlassesOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { IconButton } from '../../icon-button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip';
import type { AuditLogType } from '../Question.types';
import { AuditLogTimeline } from './AuditLogTimeline';

type AuditLogButtonProps = BaseComponentProps & {
  auditLog: AuditLogType[];
};

/**
 * Opens the change history on click rather than on hover: the timeline is long enough
 * to want reading, and a hover tooltip goes as soon as the pointer leaves it.
 */
function AuditLogButton({ style, className, auditLog }: AuditLogButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild={true}>
        <IconButton
          style={style}
          className={className}
          icon={<IoGlassesOutline />}
          aria-label="Ver historial de cambios"
          onClick={() => setOpen((v) => !v)}
        />
      </TooltipTrigger>
      <TooltipContent style={{ maxHeight: '320px' }}>
        <AuditLogTimeline auditLog={auditLog} />
      </TooltipContent>
    </Tooltip>
  );
}

export { AuditLogButton };
